import { Plus, Minus, Trash2, ShoppingBag } from 'lucide-react';

export default function Cart({ cart, setCart, currencySymbol = '$' }) {
  const updateQty = (idx, qty) => {
    const newCart = [...cart];
    if (qty <= 0) newCart.splice(idx, 1);
    else newCart[idx].quantity = qty;
    setCart(newCart);
  };

  const remove = (idx) => updateQty(idx, 0);

  if (cart.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-theme-muted">
        <ShoppingBag size={48} className="mb-4 opacity-50" />
        <p className="font-medium text-lg">Cart is empty</p>
        <p className="text-sm">Scan a barcode or select a product</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar">
        {cart.map((item, idx) => (
          <div key={idx} className="py-2.5 border-b border-theme last:border-0 flex flex-col gap-0.5 transition-all group">
            <div className="flex justify-between items-start">
              <div className="font-bold text-theme-main text-sm leading-tight group-hover:text-brand transition-colors">{item.name}</div>
              <div className="font-black text-theme-main text-base">{currencySymbol}{(item.price * item.quantity).toFixed(2)}</div>
            </div>
            
            <div className="flex justify-between items-center">
              <div className="text-[10px] font-bold text-theme-muted">
                {currencySymbol}{item.price.toFixed(2)} <span className="opacity-50">x {item.quantity}</span>
              </div>
              
              <div className="flex items-center gap-2">
                <div className="flex items-center gap-1 bg-theme-main/10 rounded-lg p-0.5 border border-theme">
                  <button 
                    onClick={() => updateQty(idx, item.quantity - 1)}
                    className="w-5 h-5 flex items-center justify-center rounded-md text-theme-muted hover:text-brand hover:bg-theme-main transition-colors"
                  >
                    <Minus size={10} />
                  </button>
                  <div className="w-5 text-center font-black text-[10px] text-theme-main">
                    {item.quantity}
                  </div>
                  <button 
                    onClick={() => updateQty(idx, item.quantity + 1)}
                    className="w-5 h-5 flex items-center justify-center rounded-md text-theme-muted hover:text-brand hover:bg-theme-main transition-colors"
                  >
                    <Plus size={10} />
                  </button>
                </div>
                <button 
                  onClick={() => remove(idx)}
                  className="p-1 text-theme-muted hover:text-rose-500 transition-colors opacity-0 group-hover:opacity-100"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}